import { UploadCloudSvgIcon } from "components/SVGIcons";
import styles from "./style.module.scss";
import { useDocumentSourcePicker } from "./useDocumentSourcePicker";

type DropzoneFileProps = {
  onChange: (event: any) => Promise<void>;
  onDrop: (files: File[]) => Promise<void>;
};

export default function DropzoneFile({ onChange, onDrop }: Readonly<DropzoneFileProps>) {
  const { fileInputRef, openPicker } = useDocumentSourcePicker(onChange);

  const handleDrop = (event: React.DragEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    onDrop(Array.from(event.dataTransfer.files));
  };

  const handleDragOver = (event: React.DragEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragEnter = (event: React.DragEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragLeave = (event: React.DragEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <button
      type="button"
      className={styles.dropZone}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}>
      <UploadCloudSvgIcon className="h-10 w-14 text-primary" />

      <div className="w-full flex flex-col items-center">
        <label
          onClick={openPicker}
          className={`${styles.uploadBtn} w-3/4 max-w-64 shadow-sm hover:shadow-md transition-all duration-200 hover:bg-primary hover:text-white py-3 font-medium tracking-wider text-sm`}>
          <span>BROWSE FILES</span>
        </label>
        <input
          ref={fileInputRef}
          type="file"
          hidden
          onChange={onChange}
          accept="image/*,application/pdf,.pdf"
        />
      </div>
    </button>
  );
}
